/* eslint-disable react/prop-types */
import React from "react";
import { graphql } from "gatsby";
import { Box, Heading } from "rebass";
import { useMeasure } from "react-use";
import { Container } from "@components/atoms";
import { Seo } from "@components/molecules";
import Block from "@components/orgranisms/Block";
import { Wrapper, ImageWrapper, Image } from "./style";

const WorkTemplate = ({ data }) => {
  const [imageRef, { width }] = useMeasure();
  const work = data.works.edges[0].node;
  const { title, image, blocks } = work;

  const height = () => {
    return (width * 62.5) / 100;
  };

  return (
    <Wrapper>
      <Seo title={title} />
      <Container>
        <Box mb={["4.5rem"]}>
          <Heading>{title}</Heading>
        </Box>

        <Box width={1} mb={["3rem", null, "6rem"]}>
          <ImageWrapper ref={imageRef}>
            <Image alt={title} fluid={image.childImageSharp.fluid} height={height()} objectFit="cover" width="100%" />
          </ImageWrapper>
        </Box>
      </Container>

      {(blocks?.length &&
        blocks?.map((block, index) => (
          <Box key={index} mb="4rem">
            <Block {...block} />
          </Box>
        ))) ||
        null}
    </Wrapper>
  );
};

export default WorkTemplate;

export const query = graphql`
  query Work($slug: String!) {
    works: allStrapiWork(filter: { slug: { eq: $slug } }) {
      edges {
        node {
          title
          slug
          excerpt
          id
          published_at
          tags {
            id
            name
          }
          image {
            childImageSharp {
              fluid(maxWidth: 990, quality: 100) {
                ...GatsbyImageSharpFluid
              }
            }
          }
          blocks {
            type
            title
            content
            id
            caption
            data {
              title
              items
            }
            img {
              childImageSharp {
                fluid(maxWidth: 1200, quality: 100) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
          }
        }
      }
    }
  }
`;
